import AssetLayout from './components/AssetLayout';

const Assets: React.FC = () => {
  return <AssetLayout />;
};

export default Assets;
